<template>
  <div class="m-0 p-0">
    <p class="m-0 worksansr">
      {{
        question.alternatives[0].text
          ? question.alternatives[0].text
          : "Não foi respondido!"
      }}
    </p>
  </div>
</template>

<script>
export default {
  name: "Question",
  props: {
    category_id: [String, Number],
    question: Object,
  },
};
</script>
